var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FunnelTravelChange',_vm._b({},'FunnelTravelChange',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }